export default function resumeTest() {
  this.pageStartTime = Date.now() - this.pageTimeSpent; // keep track of time spent solving test
  this.startTimer(this.config.pageTimeAllowed - this.pageTimeSpent); // continue timer
  this.testPaused = false;
  // this.$store.commit('pauseBarMut')
  // this.$emit('resumeTest') < use this to resume test
  this.pageTimer(); // continue pageTimer
}
